import React, { useRef, useEffect } from "react";
import Chart from "chart.js/auto";

function ChartCampagne({ data, options }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current && chartInstance.current) {
      chartInstance.current.destroy();
    }

    const myChartRef = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(myChartRef, {
      type: "line",
      data: data,
      options: {
        scales: {
          x: {
            ticks: {
              callback: function (value, index, values) {
                return value;
              },
            },
          },
          y: {
            ticks: {
              beginAtZero: true,
              stepSize: 10,
            },
            min: 0,
            max: 100,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "Campagnes",
            font: { size: 20 },
          },
        },
        ...options,
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, options]);

  return <canvas ref={chartRef} />;
}

export default ChartCampagne;
